/* ============================================================
   DATZZY — footer newsletter → Klaviyo (Stage 8)
   ------------------------------------------------------------
   Replaces ONLY the submit logic of the approved footer form. Posts the e-mail to
   Klaviyo's public Client API (/client/subscriptions) with SUBSCRIBED marketing
   consent for the configured list, triggering the list's double opt-in. The design,
   markup, input, arrow button, a11y and message placement are unchanged.

   Security: the Client API is authenticated only by the PUBLIC company/site id
   (safe to expose, same value the Klaviyo onsite embed already ships). No private
   API key is ever used or referenced. If no key is configured on the form, it is
   auto-detected from the enabled Klaviyo onsite <script>.
   ============================================================ */
(function(){
  // Revision that supports the profile `subscriptions` object on /client/subscriptions.
  var REVISION = '2025-07-15';

  // Prefer the browser-native email validity of <input type="email"> (accepts dots,
  // plus-aliases, hyphens, subdomains). Permissive fallback only if the input or the
  // Constraint Validation API is unavailable — never an overly restrictive regex.
  function isValidEmail(input, value){
    if(input && typeof input.checkValidity === 'function' && input.validity){
      return value !== '' && input.checkValidity() && input.validity.valid;
    }
    return /^\S+@\S+\.\S+$/.test(value);
  }

  function companyId(form){
    if(form.dataset.klaviyoCompany) return form.dataset.klaviyoCompany;
    // Auto-detect the public company id from the Klaviyo onsite embed script URL,
    // e.g. .../onsite/js/COMPANY/klaviyo.js or ...klaviyo.js?company_id=COMPANY
    var scripts = document.querySelectorAll('script[src*="klaviyo"]');
    for(var i = 0; i < scripts.length; i++){
      var src = scripts[i].src || '';
      var m = src.match(/[?&]company_id=([A-Za-z0-9]+)/) || src.match(/onsite\/js\/([A-Za-z0-9]+)\//);
      if(m) return m[1];
    }
    return null;
  }

  function bind(form){
    if(form.dataset.klaviyoBound) return;
    form.dataset.klaviyoBound = '1';

    var input  = form.querySelector('input[type="email"]');
    var btn    = form.querySelector('button[type="submit"]') || form.querySelector('.btn');
    var msg    = (form.parentNode || document).querySelector('[data-klaviyo-msg]');
    var listId = form.dataset.klaviyoList;
    var d      = form.dataset;
    var submitting = false;

    function show(text, ok){
      if(!msg) return;
      msg.textContent = text;
      msg.hidden = false;
      msg.classList.remove('dz-news-ok', 'dz-news-err');
      msg.classList.add(ok ? 'dz-news-ok' : 'dz-news-err');
      msg.setAttribute('role', ok ? 'status' : 'alert');
    }
    function loading(on){
      submitting = on;
      if(btn){ btn.disabled = on; if(on){ btn.setAttribute('aria-busy', 'true'); } else { btn.removeAttribute('aria-busy'); } }
      form.classList.toggle('is-loading', on);
    }

    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(submitting) return;                      // prevent duplicate submissions
      // Trim, then write the trimmed value back so native validation (and the POST)
      // both see the cleaned value — a stray leading/trailing space would otherwise
      // make an <input type="email"> report invalid.
      var email = ((input && input.value) || '').trim();
      if(input) input.value = email;
      if(!isValidEmail(input, email)){
        show(d.msgInvalid || 'Podaj poprawny adres e-mail.', false);
        if(input) input.focus();
        return;
      }
      var company = companyId(form);
      if(!company || !listId){
        show(d.msgError || 'Nie udało się zapisać. Spróbuj ponownie później.', false);
        return;
      }
      loading(true);

      // Official Klaviyo Client Subscriptions payload. `subscriptions` lives at
      // data.attributes.profile.data.attributes.subscriptions — no extra profile wrapper.
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      };

      // TEMP debug (Stage: remove after 202 is confirmed): log the final payload once.
      if(!window.__dzKlaviyoLogged){
        window.__dzKlaviyoLogged = true;
        try {
          console.log('[DATZZY Klaviyo] POST /client/subscriptions payload:', JSON.stringify(body, null, 2));
          console.log('[DATZZY Klaviyo] subscriptions pointer: data.attributes.profile.data.attributes.subscriptions =', JSON.stringify(body.data.attributes.profile.data.attributes.subscriptions));
        } catch(e){}
      }

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': REVISION },
        body: JSON.stringify(body)
      }).then(function(r){
        try { console.log('[DATZZY Klaviyo] response status:', r.status); } catch(e){}   // TEMP debug — remove after verification
        // 202 Accepted = queued (also for existing subscribers → double opt-in re-sent).
        if(r.status === 202 || (r.status >= 200 && r.status < 300)){
          show(d.msgSuccess || 'Sprawdź swoją skrzynkę e-mail i potwierdź zapis.', true);
          if(input) input.value = '';
        } else {
          // The e-mail already passed native validation, so a non-2xx (incl. 400) is a
          // service/config problem — show the generic error, never mislabel a valid
          // address as "invalid e-mail".
          show(d.msgError || 'Nie udało się zapisać. Spróbuj ponownie później.', false);
        }
      }).catch(function(){
        show(d.msgError || 'Nie udało się zapisać. Spróbuj ponownie później.', false);
      }).then(function(){
        loading(false);
      });
    });
  }

  function init(){
    var forms = document.querySelectorAll('[data-klaviyo-form]');
    for(var i = 0; i < forms.length; i++) bind(forms[i]);
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
